module.exports = __webpack_public_path__ + "preset.61e8872e150858534b5277c6465e8920.png";